<template>
    <div class="plan-page-header">
        <div class="plan-page-header-logo">
            <img src="/images/business-v2/logo/litt_business_logo.svg" alt="">
        </div>
        <div class="plan-page-header-signin">
            <select name="preferredCountry" id="preferredCountry" @change="setPrices">
                <option value="AU" :selected="this.formData.countryCode=='AU'">🇦🇺 Australia </option>
                <option value="US" :selected="this.formData.countryCode=='US'">🇺🇸 USA </option>
                <option value="ID" :selected="this.formData.countryCode=='ID'">🇲🇨 Indonesia </option>
            </select>
            <a href="/business/login" class="plan-page-header-signin-link">Sign in</a>
        </div>
    </div>
    <div class="plan-page-banner">
        <video src="/videos/LITT-For-Businesses.mp4" title="Introduction to LITT Reward Partners" poster="/images/business-v2/subscription-video-thumbnail.png" frameborder="0" allowfullscreen controls autoplay muted></video>
    </div>
    
    <div class="pricing-plan-container">
        <div class="subs-text">Join today and pay no Joining fee!</div>
        <div class="subs-text-small">Limited time offer</div>
        <div class="subs-inner-text">Become a LITT Reward Partner and unlock unparalleled tools to enhance your customer
acquisition and retention strategies. Gain exclusive access to our cutting-edge toolkit
designed to elevate your business. <br><br>
Leverage our proprietary geo-fence technology to attract customers to your stores and reward
existing customers with enticing incentives for their next purchase. Join us and revolutionize
your approach to customer engagement.</div>
        <div class="sub-period-selection">
            <div class="option-wrap ui buttons big">
                <button
                    class="ui button toggle"
                    @click="toggle"
                    :class="[yearlyPlan ? 'active' : 'plan-selected']"
                    :disabled="!yearlyPlan"
                >Monthly</button>
                <button
                    class="ui button toggle"
                    @click="toggle"
                    :class="[!yearlyPlan ? 'active' : 'plan-selected']"
                    :disabled="yearlyPlan"
                >Yearly</button>
            </div>
            <div class="option-wrap-subtitle"> <div class="subscription-discount"> Select Yearly and save 20%! </div></div>
            <div class="option-wrap">
                <div class="option-container">
                    <div class="gold-partner-title">Gold Partner <img src="/images/subscription/popular-flag.png"></div>
                    <div class="subtitle-text">Become a Gold Partner today and enhance your business with our top tier suite presenting exclusive advantages such as access to digital gift cards, store locator, transaction reports and a 5% discount on advertising services!</div>
                    <div class="option-price"> <div class="price-tag">{{ currencyCode }}{{ this.formData.selectedPlan.price }}</div><div class="price-counting-unit">{{ this.paymentUnit }}</div></div>
                    <div class="onceoff-fee">+{{ currencyCode }}{{ this.formData.selectedPlan.joining_fee }} once-off joining fee</div>
                    <div class="plan-details-text">
                        <div class="option-detail"><span class="glyphicon glyphicon-ok"></span> Geofence promotions.</div>
                        <div class="option-detail"><span class="glyphicon glyphicon-ok"></span> Loyalty promotions.</div>
                        <div class="option-detail"><span class="glyphicon glyphicon-ok"></span> 5% discount on promotions.</div>
                        <div class="option-detail"><span class="glyphicon glyphicon-ok"></span> Transaction reports.</div>
                        <div class="option-detail"><span class="glyphicon glyphicon-ok"></span> Promotion analytics.</div>
                        <div class="option-detail"><span class="glyphicon glyphicon-ok"></span> Store profile optimization.</div>
                    </div>
                    <div class="plan-button-wrap">
                        <button class="button selectPackage" data-type="Gold Partner" @click="clickType">Join Now</button>
                    </div>
                </div>
                <div class="option-container">
                    <div class="title-text">Brand Partner</div>
                    <div class="subtitle-text">Ideal for brands or affiliates looking to expand their reach, our offering provides premium
advertising opportunities and powerful tools to enhance your company’s presence. Unlock
unparalleled marketing impact today!</div>
                    <div class="option-price"><span class="price-tag">Pay per promotion</span></div>
                    <div class="plan-details-text">
                        <div class="option-detail"><span class="glyphicon glyphicon-ok"></span> Geofence promotions.</div>
                        <div class="option-detail"><span class="glyphicon glyphicon-ok"></span> Promotion analytics.</div>
                        <div class="option-detail"><span class="glyphicon glyphicon-ok"></span> Cost per promotion.</div>
                    </div>
                    <div class="plan-button-wrap">
                        <button class="unselect-button selectPackage" data-type="Brand Partner" @click="clickType">Join Now</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="promo-code-section"><img src="/images/subscription/join-today.png"></div>
        <div class="subs-text">Compare Plans</div>
        <table id='pricing-plan-table'>
            <tbody>
                <tr class="plan-comparision-header">
                    <th class="fx">Key features</th>
                    <th class="gold">GOLD PARTNER</th>
                    <th class="gk">BRAND PARTNER</th>
                </tr>
                <tr>
                    <td class="ed">Access to Reward Partner Dashboard</td>
                    <td class="tr"><i class="glyphicon glyphicon-ok"></i></td>
                    <td class="tr"><i class="glyphicon glyphicon-ok"></i></td>
                </tr>
                <tr>
                    <td class="ed">Advertise promotions and reward offers</td>
                    <td class="tr"><i class="glyphicon glyphicon-ok"></i></td>
                    <td class="tr"><i class="glyphicon glyphicon-ok"></i></td>
                </tr>
                <tr>
                    <td class="ed">Promotion reports and analytics</td>
                    <td class="tr"><i class="glyphicon glyphicon-ok"></i></td>
                    <td class="tr"><i class="glyphicon glyphicon-ok"></i></td>
                </tr>
                <tr>
                    <td class="ed">LITT Pay transaction reports</td>
                    <td class="tr"><i class="glyphicon glyphicon-ok"></i></td>
                    <td class="tr"><i class="glyphicon glyphicon-remove"></i></td>
                </tr>
                <tr>
                    <td class="ed">Create digital Gift Cards</td>
                    <td class="tr"><i class="glyphicon glyphicon-ok"></i></td>
                    <td class="tr"><i class="glyphicon glyphicon-remove"></i></td>
                </tr>
                <tr>
                    <td class="ed">Store Directory and Map listing</td>
                    <td class="tr"><i class="glyphicon glyphicon-ok"></i></td>
                    <td class="tr"><i class="glyphicon glyphicon-remove"></i></td>
                </tr>
                <tr>
                    <td class="ed">Create social posts and build followers</td>
                    <td class="tr"><i class="glyphicon glyphicon-ok"></i></td>
                    <td class="tr"><i class="glyphicon glyphicon-remove"></i></td>
                </tr>
                <tr>
                    <td class="ed">Cashback promotions</td>
                    <td class="tr"><i class="glyphicon glyphicon-ok"></i></td>
                    <td class="tr"><i class="glyphicon glyphicon-remove"></i></td>
                </tr>
                <tr>
                    <td class="ed">5% discount on promotional advertising</td>
                    <td class="tr"><i class="glyphicon glyphicon-ok"></i></td>
                    <td class="tr"><i class="glyphicon glyphicon-remove"></i></td>
                </tr>
                <tr>
                    <td class="fx"></td>
                    <td class="gk"><a class="plan-selector-bottom" data-type="Gold Partner" @click="clickType">Select</a></td>
                    <td class="gk"><a class="plan-selector-bottom" data-type="Brand Partner" @click="clickType">Select</a></td>
                </tr>
            </tbody>
        </table>
        <div class="table-description-bottom" style="display: none; height: 0;">* LITT Pay transaction fees applicable on payments made with LITT Visa or LITT QR Pay. Special offer free threshold may apply.  Please check the LITT Admin Settings dashboard for applicable rates.</div>
        <div class="contact-us-banner"><a href="mailto:partners@thelittapp.com"><img src="/images/subscription/contact-us-new1.png" alt=""></a></div>

        <div v-if="v$.type.$error" class="help-block" style="text-align:center;">Please pick a business type to continue</div>            
    </div>
</template>

<script>
    import { required } from '@vuelidate/validators';
    import useVuelidate from '@vuelidate/core';
    import DateRangePicker from '../DateRangePicker.vue';
    import moment from 'moment';
    import $ from 'jquery';

    export default {
        components: { DateRangePicker, moment }, 
        setup(){
            return { v$: useVuelidate() }
        },
        props: ['formData', 'headers', 'showPrice', 'contents', 'formData', 'subscriptionplans', 'countrycode'],
        emits: ["update", "next"],
        data() {
            return {
                currencyCode: "",
                type: "",
                yearlyPlan: false,
                planCycle: 'Monthly',
                defaultFreeTrial: 0,
                planFee: 0, 
                joiningFee: 0,
                paymentUnit: "/location/month",
                currentPlan: "",
                plans: JSON.parse(this.subscriptionplans),
                originalPlanStartDateDisplay: "",
                originalPlanStartDate: "",
                originalPlanEndDate: "",
                userCountryCode: ""
            }
        },
        methods: {
            moment: function () {
                return moment();
            },
            toggle() {
                this.yearlyPlan = !this.yearlyPlan;

                this.planCycle = this.yearlyPlan ? 'Yearly' : 'Monthly';
                this.currentPlan = this.plans.find((element) => (element.billing_cycle === this.planCycle && element.country.code == this.userCountryCode));
                this.planFee = this.currentPlan.price;
                this.joiningFee = this.currentPlan.joining_fee;
                this.defaultFreeTrial = this.currentPlan.free_trial_duration;
                this.paymentUnit = "/location/" + this.planCycle.toLowerCase();
                this.addDefaultFreeTrial();

                this.submit();
            },
            clickType(type){
                this.type = type.target.getAttribute('data-type');
                this.submit();
                this.$emit('next');
            },
            submit(){
                this.$emit('update', {
                    data:{
                        businessType: this.type,
                        planFee: this.planFee,
                        joiningFee: this.joiningFee,
                        originalPlanFee: this.planFee,
                        defaultFreeTrial: this.defaultFreeTrial,
                        originalJoiningFee: this.joiningFee,
                        physicalStore: this.type == 'Gold Partner',
                        yearlyPlan: this.yearlyPlan,
                        selectedPlan: this.currentPlan,
                        selectedPlanId: this.currentPlan.id,
                        originalPlanStartDateDisplay: this.originalPlanStartDateDisplay,
                        originalPlanStartDate: this.originalPlanStartDate,
                        originalPlanEndDate: this.originalPlanEndDate,
                        countryCode: this.userCountryCode
                    },
                    valid: !this.v$.$invalid
                });
            },
            addDefaultFreeTrial() {
                this.originalPlanStartDateDisplay = moment().add(this.defaultFreeTrial, 'M').format('D MMM YYYY');
                this.originalPlanStartDate = moment().add(this.defaultFreeTrial, 'M').format('YYYY-MM-DD 00:00:00');
                this.originalPlanEndDate = moment(this.originalPlanStartDate, 'YYYY-MM-DD 00:00:00').add(1, this.currentPlan.billing_cycle == 'Yearly' ? 'y' : 'M').format('YYYY-MM-DD 00:00:00');
            },
            setPrices() {
                this.userCountryCode = $("#preferredCountry").val();
                this.currentPlan = this.plans.find((element) => (element.billing_cycle === this.planCycle && element.country.code == this.userCountryCode));
                this.planFee = this.currentPlan.price;
                this.joiningFee = this.currentPlan.joining_fee;
                this.defaultFreeTrial = this.currentPlan.free_trial_duration;
                this.currencyCode = this.currentPlan.currency.code_symbol;

                this.addDefaultFreeTrial();
                this.submit();
            },
            switchCountry() {
                setPrices();
            }
        },
        mounted() {
            this.userCountryCode = this.countrycode;
            this.setPrices();
        },
        created() {
            window.scrollTo(0,0);
        },
        validations:{
            type: {required}
        }
    };
</script>
